import { render, staticRenderFns } from "./withdrawal-error.vue?vue&type=template&id=31ae30d2&scoped=true&"
import script from "./withdrawal-error.vue?vue&type=script&lang=js&"
export * from "./withdrawal-error.vue?vue&type=script&lang=js&"
import style0 from "./withdrawal-error.vue?vue&type=style&index=0&id=31ae30d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae30d2",
  null
  
)

export default component.exports